// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2444":"9aba281d709911f6","7383":"73025f5067cdf19a","7863":"42b54f766380dbe1","9622":"572f389b7f921f4e"}[chunkId] + ".css";
};